"use strict";

// =================================== Fly =========================
var flying = true;
var justRested = false;
var flyTimeout;
$(document).ready(function () {
  if ($("#fly").length > 0) {
    animateDiv();

    $("#fly img").click(function () {
      flyingOff();
    });

    var toggleFly = $('.toggle_fly');
    toggleFly.addClass('show-fly-btn');
    toggleFly.click(function (e) {
      e.preventDefault();
      TweenMax.killTweensOf($('.a'));

      if (flying) {
        flying = false;
        $('body').removeClass('has-fly');
        $('#fly.a').hide();
      } else {
        flying = true;
        justRested = true;
        animateDiv();
      }
    });

    toggleFly.mouseup(function () {
      $(this).children('a').removeClass('click');
    });

    toggleFly.mousedown(function () {
      $(this).children('a').addClass('click');
    });
  }
});

function flyingOff() {
  clearTimeout(flyTimeout);
  flying = false;

  TweenMax.killTweensOf($('.a'));
  var h = $('body').height();
  TweenMax.to($('.a'), 0.5, { y: h, onComplete: completeFlyOff, ease: Power4.easeIn });
}

function completeFlyOff() {
  $('#fly.a').hide();
}

function makeNewPosition($container) {

  // Get viewport dimensions (remove the dimension of the div)
  $container = $container || $(window);
  var h = $('body').height() - 50;
  var w = $('body').width() - 50;

  var nh = Math.floor(Math.random() * h);
  var nw = Math.floor(Math.random() * w);

  return [nh, nw];
}

function animateDiv() {
  $('#fly.a').show();

  if (!$('body').hasClass('has-fly')) $('body').addClass('has-fly');

  if (!justRested) needRest();

  if (flying == true) {
    justRested = false;
    var $target = $('.a');
    var newq = makeNewPosition($target.parent());
    var oldq = $target.offset();
    var speed = calcSpeed([oldq.top, oldq.left], newq);

    var midPos = makeNewPosition($target.parent());
    var desPos = makeNewPosition($target.parent());
    TweenMax.to($('.a'), speed / 1000, { bezier: { type: "thru", curviness: 0.5, values: [{ x: newq[1], y: newq[0] }, { x: 0, y: newq[0] / 4 }, { x: newq[1] / 2, y: 0 }, { x: newq[1], y: newq[0] }], autoRotate: ["x", "y", "rotation", 90, false] }, onComplete: completeAnimateHandler, ease: Linear.easeNone });
  }
}

function completeAnimateHandler() {
  animateDiv();
}

function needRest() {
  var totalRestPoint = $('.rest-point').length;
  if (totalRestPoint > 0) {
    var restPointId = Math.floor(Math.random() * totalRestPoint + 1);
    if (Math.floor(Math.random() * 2 + 1) % 2 == 0) {
      var restPoint = $('#rest-point-' + restPointId).position();
      var restPointOffset = $('#rest-point-' + restPointId).offset();

      restPoint.top = restPointOffset.top;
      restPoint.left = restPointOffset.left;

      flying = false;
      justRested = true;

      var $target = $('.a');
      var newq = makeNewPosition($target.parent());

      var desPos = [];
      desPos.push(parseInt(restPoint.top) - 50);
      desPos.push(parseInt(restPoint.left) - 50);

      TweenMax.to($('.a'), 1, { bezier: { type: "thru", values: [{ x: newq[1], y: newq[0] }, { x: desPos[1] / 4, y: desPos[0] / 4 }, { x: desPos[1] / 2, y: desPos[0] / 2 }, { x: desPos[1], y: desPos[0] }], autoRotate: ["x", "y", "rotation", 90, false] }, onComplete: completeRestHandler, onCompleteParams: [restPoint], ease: Linear.easeNone });
    }
  }
}

function completeRestHandler(restPoint) {
  var second = Math.floor(Math.random() * 5 + 1) * 1000;
  flyTimeout = setTimeout(function () {
    flying = true;
    animateDiv();
  }, second);
}

function calcSpeed(prev, next) {

  var x = Math.abs(prev[1] - next[1]);
  var y = Math.abs(prev[0] - next[0]);

  var greatest = x > y ? x : y;

  var speedModifier = 0.25;

  var speed = Math.ceil(greatest / speedModifier);

  return speed;
}